// src/translations/hero.js
export default {
  en: {
    hero_pretitle: "Real Estate Excellence",
    hero_title: "Buy. Sell. Rent.",
    hero_subtitle: "Your trusted partner in real estate. From finding your dream home to managing valuable investments, I guide you through every step with expertise, transparency, and a commitment to results.",
    cta_button: "Start Now",
    scroll_text: "EXPLORE"
  },
  it: {
    hero_pretitle: "Eccellenza Immobiliare",
    hero_title: "Compra. Vendi. Affitta.",
    hero_subtitle: "Il tuo partner di fiducia nel mercato immobiliare. Dalla ricerca della casa perfetta alla gestione di investimenti importanti, ti guido in ogni fase con competenza, trasparenza e dedizione ai risultati.",
    cta_button: "Inizia Ora",
    scroll_text: "ESPLORA"
  }
};